import OnboardModalHeader from './OnboardModalHeader'

export default OnboardModalHeader;
